import { Box, Stack, Typography, Select, MenuItem } from "@mui/material";
import React, { useState, useEffect } from "react";
import images from "../../constant/images";
import { supportedLanguage, languageLabels } from "../../constant/constant";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import "../glassEffect/index.scss";
import TypingAnimation from "../typing-animation";

function Header() {
  const [selectedLang, setSelectedLang] = useState(i18n.language || "en-US");

  useEffect(() => {
    const onStorageChange = (event) => {
      if (event.key === "i18nextLng" && event.newValue) {
        i18n.changeLanguage(event.newValue);
      }
    };

    window.addEventListener("storage", onStorageChange);
    return () => {
      window.removeEventListener("storage", onStorageChange);
    };
  }, []);

  const CustomDropdownIndicator = (props) => {
    return (
      <Box
        component="img"
        src={images.Vector}
        alt="dropdown"
        sx={{
          width: 10,
          height: 10,
          top: "10%",
          transform: "translateY(-40%)",
          pointerEvents: "none",
        }}
        {...props}
      />
    );
  };

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent="space-between"
        alignItems={"center"}
        sx={{
          zIndex: 2,
        }}
      >
        <Box height="2.5rem">
          <Typography
            sx={{
              ml: ".5rem",
              lineHeight: 1,
              "& .typing-text": {
                fontSize: "2.5rem",
                color: (theme) => theme.palette.primary.tooltipBackground,
              },
            }}
          >
            <TypingAnimation text="SCAi" />
          </Typography>
        </Box>

        <Box
          sx={{
            pointerEvents: "auto",
          }}
        >
          <Select
            IconComponent={CustomDropdownIndicator}
            sx={{
              "& .MuiSelect-select": {
                paddingTop: "0 !important",
                paddingBottom: "0 !important",
              },

              "& .MuiOutlinedInput-input": {
                paddingTop: "0 !important",
                paddingBottom: "0 !important",
              },

              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },

              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },

              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },

              "& .MuiOutlinedInput-root fieldset": {
                borderColor: "transparent",
              },

              "&:focus": {
                outline: "none",
              },

              p: 0,
              border: "none",
            }}
            value={selectedLang || "en-US"}
            displayEmpty
            onChange={(e) => {
              const selected = e.target.value;
              i18n.changeLanguage(selected);
              setSelectedLang(selected);
            }}
            renderValue={(value) => (
              <Stack direction="row" gap="0.5rem" alignItems="center">
                <Box
                  component="img"
                  src={images.languageLogo}
                  alt="earth"
                  width={20}
                  height={20}
                />
                <Typography
                  sx={{
                    color: (theme) => theme.palette.primary.tooltipBackground,
                    fontSize: "1.2rem",
                  }}
                >
                  {languageLabels[value] || "Select Language"}
                </Typography>
              </Stack>
            )}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1.2,
                  borderRadius: "1.2rem",

                  /* REAL GLASS */
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.03))",
                  backdropFilter: "blur(22px) saturate(200%)",
                  WebkitBackdropFilter: "blur(22px) saturate(200%)",

                  /* GLASS DEPTH */
                  border: "1px solid rgba(255,255,255,0.25)",
                  boxShadow: `
          0 12px 40px rgba(0,0,0,0.35),
          inset 0 1px 1px rgba(255,255,255,0.35)
        `,

                  overflow: "hidden",

                  /* GLASS REFLECTION */
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    borderRadius: "1.2rem",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.35), transparent 40%)",
                    pointerEvents: "none",
                  },
                },
              },
              MenuListProps: {
                sx: { p: 0 }
              },
            }}
          >
            {supportedLanguage.map((lang) => (
              <MenuItem
                key={lang}
                value={lang}
                sx={{
                  fontSize: "1.1rem",
                  fontWeight: 400,
                  color: (theme) => theme.palette.primary.activeTextColor,
                  transition: "all 0.25s ease",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.1))",
                  },

                  /* SELECTED ITEM = BOLDER */
                  "&.Mui-selected": {
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.35), rgba(255,255,255,0.15))",
                  },

                  "&.Mui-selected:hover": {
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.4), rgba(255,255,255,0.2))",
                  },
                }}
              >
                {languageLabels[lang] || "Unknown"}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Stack>
    </>
  );
}

export default Header;
